import {IPrayerCategory} from './PrayerCategory';
import HeaderWithIcons from '../app/HeaderWithIcons';
import {Box, Divider, IconButton, Typography} from '@mui/material';
import {useState} from 'react';
import ZoomInIcon from '@icons/ZoomInIcon';
import ZoomOutIcon from '@icons/ZoomOutIcon';
import TranslateIcon from '@icons/TranslateIcon';

interface IProps {
	prayer: IPrayerCategory,
}

export default function PrayerContent({prayer}: IProps) {
	const [fontSize, setFontSize] = useState(16);
	const [translate, setTranslate] = useState(false);
	
	const increaseFontSize = () => {
		if (fontSize < 25) {
			setFontSize(fontSize + 1);
		}
	};
	
	const decreaseFontSize = () => {
		if (fontSize > 8) {
			setFontSize(fontSize - 1);
		}
	};
	
	const toggleTranslate = () => {
		setTranslate(!translate);
	};
	
	return (
		<div className="w-full h-full flex flex-col space-y-2">
			<HeaderWithIcons title={prayer.name}/>
			<div className="mx-4 grow">
				{
					prayer.texts!.map((text, index) => <div key={index}>
						{
							translate ?
								<>
									<Typography
										sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? 'grey.50' : 'background.paper'}}
										style={{fontSize}} className="font-medium px-2 leading-9 rounded-sm">
										{text.arabic} {
										Number(text.verse) > 0 ? `(${Number(text.verse)})` : null
									}
									</Typography>
									<Typography style={{fontSize}} className="font-medium px-2 leading-9 rounded-sm">
										{text.translate}
									</Typography>
								</>
								:
								<Typography
									sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? (text.arabic.length ? 'grey.50' : 'grey.0') : (text.arabic.length ? 'background.paper' : 'background.default')}}
									style={{fontSize}} className="font-medium px-2 leading-9 rounded-sm">
									{
										text.arabic.length ? <>
											{text.arabic} {
											Number(text.verse) > 0 ? `(${Number(text.verse)})` : null
										}
										</> : text.translate
									}
								</Typography>
						}
					</div>)
				}
				
				<div className="sticky bottom-4">
					<div className="flex flex-row">
						<div className="grow"></div>
						<div className="ml-4">
							<IconButton sx={{bgcolor: translate ? 'grey.50' : 'white'}} className="shadow-md mb-2"
							            onClick={toggleTranslate}><TranslateIcon active={translate}/></IconButton>
							<Box className="rounded-full flex flex-col bg-white shadow-md">
								<IconButton onClick={increaseFontSize}><ZoomInIcon/></IconButton>
								<Divider/>
								<IconButton onClick={decreaseFontSize}><ZoomOutIcon/></IconButton>
							</Box>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
